import Vue from 'vue';
import App from './App.vue';
import router, { addDynamicRoutes, setDynamicRoutesLoaded } from './router';
import store from './store';
//
import Mixin from '@/utils/globalMixin';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';

import { i18n } from '@/locales/locale';
import initializeData from '@/utils/initializeData';
import { fetchTopic } from '@/api/base';

import VueAwesomeSwiper from 'vue-awesome-swiper';

// import style (>= Swiper 6.x)
import 'swiper/dist/css/swiper.min.css';

import lightgallery from 'lightgallery.js';
import 'lightgallery.js/dist/css/lightgallery.min.css';

Vue.use(lightgallery);

// Install BootstrapVue
Vue.use(VueAwesomeSwiper);
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.mixin(Mixin);

Vue.config.productionTip = false;

import './assets/css/theme.scss';

// 初始化动态路由
async function initApp() {
  try {
    const { data } = await fetchTopic({ slug: initializeData.slug || 'week2026' });
    if (data.menu && data.menu['main-menu']) {
      addDynamicRoutes(data.menu['main-menu']);
    }
    // 标记动态路由已加载
    setDynamicRoutesLoaded(true);
  } catch (error) {
    console.warn('Failed to load dynamic routes:', error);
  }

  new Vue({
    data: function() {
      return {
        week: initializeData.slug || 'PLDxxxxxx0001',
        topicSlug: initializeData.slug || 'PLDxxxxxx0001',
      };
    },
    i18n,
    router,
    store,
    render: (h) => h(App),
  }).$mount('#app');
}

initApp();
